import { ApiResult, PaginatedResponse, request, safeRequest } from '@synergy/api';

import { OrderedArticle } from './models/ordered-article';
import { memberOrderParams } from '../../common/utils/member-order-params';

export class BuyAgainApi {
    constructor(protected baseUrl: string) {}

    public cget = (searchParams: URLSearchParams): Promise<ApiResult<PaginatedResponse<OrderedArticle>>> =>
        safeRequest(
            () => request.get(`${this.baseUrl}/ordered-articles`, { params: memberOrderParams(searchParams) }),
            response => response.data
        );
}
